import { render, staticRenderFns } from "./ModalCustomerGroupFiles.vue?vue&type=template&id=63f156cc&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ModalCustomerGroupFiles.vue?vue&type=script&lang=js&"
export * from "./ModalCustomerGroupFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f156cc",
  null
  
)

export default component.exports